import Tenancies from '../views/Tenancies';
import TenancyPropertyWrapper from '../views/TenancyPropertyWrapper';
import TenancyProperty from '../views/TenancyProperty';
import TenancyPropertyUtilities from '../views/TenancyPropertyUtilities';
import TenancyPropertyPay from '../views/TenancyPropertyPay';
import TenancyPropertyReportRepair from '../views/TenancyPropertyReportRepair';
import TenancyPropertyNotes from '../views/TenancyPropertyNotes';
import TenancyPropertyKeyDates from '../views/TenancyPropertyKeyDates';

export default [
    {
        path: '/tenancies',
        name: 'tenancies',
        component: Tenancies,
        meta: {
            title: 'Tenancies',
        },
    },
    {
        path: '/tenancies/:id',
        component: TenancyPropertyWrapper,
        meta: {
            title: 'Tenancy',
        },
        children: [
            {
                path: '',
                name: 'tenancy-property',
                component: TenancyProperty,
            },
            {
                path: 'key-dates',
                name: 'tenancy-property-key-dates',
                component: TenancyPropertyKeyDates,
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.tenants.key_dates) {
                        return next({
                            name: 'tenancy-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'utilities',
                name: 'tenancy-property-utilities',
                component: TenancyPropertyUtilities,
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.tenants.utilities) {
                        return next({
                            name: 'tenancy-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'pay',
                name: 'tenancy-property-pay',
                component: TenancyPropertyPay,
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.tenants.bank_account && ! window.meta.features.tenants.online_payments) {
                        return next({
                            name: 'tenancy-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'repairs',
                name: 'tenancy-property-request-repair',
                component: TenancyPropertyReportRepair,
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.tenants.fixflo && ! window.meta.features.tenants.report_repair_contact_details) {
                        return next({
                            name: 'tenancy-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'documents',
                name: 'tenancy-property-documents',
                component: TenancyPropertyNotes,
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.tenants.documents) {
                        return next({
                            name: 'tenancy-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
        ],
    },
];
